import { yupResolver } from '@hookform/resolvers/yup';
import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { AccountsReceivableSalesJournalReportFormModel } from '../../models';
import { FilterForm } from './FilterForm';
import { schema } from './schema';

export const FilterFormProvider: FC<{
  defaultValues: AccountsReceivableSalesJournalReportFormModel;
  onSubmit: (data: AccountsReceivableSalesJournalReportFormModel) => void;
}> = ({ defaultValues, onSubmit }) => {
  const form = useForm<AccountsReceivableSalesJournalReportFormModel>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: defaultValues,
  });

  return (
    <FormProvider {...form}>
      <FilterForm onSubmit={onSubmit} onReset={() => form.reset(defaultValues)} />
    </FormProvider>
  );
};
